<template>
    <div class="wk-input-box wk-input-box" :class="{'btn-box':btnBox===''}">
        <span class="input-left-label"  style="line-height: 5rem;">{{label}}</span>
        <div class="posi-relative" :class="classCpt">
            <slot></slot>
        </div>
    </div>
</template>
 
<script>
    export default {
        name: 'inputlsit',
        props: ['label','classCpt','btnBox'],
        mounted(){
        }
    }
</script>
<style lang="less" scoped>
    .wk-input-box{
        margin:.9rem 0;
        // 条款
        .terms-box{
            width:17.3rem;
            padding:0 0 0 0;
            p.terms-img img{
                width: 1rem;
                height: 1rem;
                margin: 0 .5rem 0 0;
            }
            p.terms-content{
                padding:0 !important; 
                a{
                    color:#123593;
                    cursor: pointer;
                }
            }
        }  
    }
</style>
<style lang="less">
    .wk-input-box{
        //需要嵌套一层时的 btn-box
        .btn-block{
            margin:1rem 0 0 -4rem;
        }
        .btn-box{
            padding-top:1.5rem;
            button{
                width: 8.2rem;
            }
        }
        .el-input__inner{ 
             width:17.5rem !important;
        }
        >div.margin_left{
            width:100%;
            // padding-left:7rem;
        }
    }
    // 不要嵌套 wk-input-box 就是 btn 盒子时
    .btn-box{
        padding-top:1rem;
    }
</style>




// WEBPACK FOOTER //
// src/components/BaseCpts/wkInputBoxs.vue